import { useContext } from 'react';
import type { RegistrationApi } from '@signplatform/registration-api';
import ApiContext from '../components/ApiProvider/ApiContext';

export default function useAuthApiClient(): RegistrationApi {
  const { authApi } = useContext(ApiContext);

  return authApi;
}
